<template>
  <div>
    <div>
      <div ref="card"></div>
      <p id="card-error" role="alert"></p>
      <v-btn
       :loading="paymentStarted" 
       :disabled="disablePayment || disablePaymentCommon || isDisabled" @click="proceedPayment">CONFIRM PAYMENT</v-btn>
    </div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import CebelcaService from '../../services/CebelcaService'
import { mapState } from 'vuex';
import moment from 'moment'

export default {
  data() {
    return {
      stripe: null,
      elements: null,
      card: null,
      isDisabled: true,
      clientSecret: '',
      paymentStarted: false,
      paymentResponse: {},
      currentCartItems: [],
      delayPayment: false
    }
  },
  async mounted() {
    this.currentCartItems = JSON.parse(JSON.stringify(this.cartItems))
    // this.getPaymentIntent()
    let self = this
    this.stripe = await loadStripe(
      await this.$store.dispatch('getKeys', this.productDetails.product_Id)
    )
    this.elements = this.stripe.elements()
    this.card = this.elements.create('card', {
      hidePostalCode: true
    })
    this.card.mount(this.$refs.card)
    this.card.on('change', function (event) {
      document.querySelector('#card-error').textContent = event.error ? event.error.message : ''
        if(event.complete) {
          self.isDisabled = false
        } else {
          self.isDisabled = true
        }
    })
  },
  methods: {
    async getPaymentIntent(paymentMethodId) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getPaymentIntent', {
          productId: this.productDetails.product_Id,
          body: this.generateBody(paymentMethodId)
        })
        .then((paymentIntent) => {
          this.clientSecret = paymentIntent.client_secret
          return resolve(paymentIntent)
        })
        .catch((err) => {
          this.$emit('error-response', err)
          return reject(err)
        })
      })
    },
    async proceedPayment() {
      if (
        this.productDetails.type &&
        this.productDetails.type.toLowerCase().trim() === 'alcoholic' &&
        (new Date().getHours() >= 21 || new Date().getHours() <= 7)
      ) {
        this.delayPayment = true
      } else {
        this.delayPayment = false
      }

      if (this.$parent.resetCart) this.$parent.resetCart()
      else if (this.$parent.$parent.resetCart) this.$parent.$parent.resetCart()
      else this.$parent.$parent.$parent.resetCart()

      let self = this
      self.paymentStarted = true
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card,
        billing_details: {
          name: this.productDetails.unitName,
          address: {
            line1: this.productDetails.unitAddress,
            city: this.productDetails.unitCity,
            postal_code: this.productDetails.unitPostalCode,
            country: 'SL',
          }
        }
      })

      if (error) {
        console.log(error.message)
        self.paymentStarted = false
      } else {
        try {
          const response = await this.getPaymentIntent(paymentMethod.id)
          await self.upsertOrder(paymentMethod.id, response.payment_intent_id)

          self.paymentResponse = response
          self.paymentResponse.last4 = paymentMethod.card.last4
          self.paymentResponse.amount = this.cartTotalPrice
          self.paymentResponse.currency = 'EUR'
          self.paymentResponse.delayPayment = this.delayPayment
          self.$emit('success-response', self.paymentResponse)
        } catch (error) {
          console.log(error)
        } finally {
          self.paymentStarted = false
        }
      }
    },
    generateBody(paymentMethodId) {
      const body = {}
      body.amount = this.cartTotalPrice * 100
      body.currency = 'eur'
      body.paymentMethodId = paymentMethodId
      body.delayPayment = this.delayPayment
      body.cartId = this.currentCartItems[0].cart_id
      return body
    },
    updateStock() {
      this.$store.dispatch('updateStock', this.currentCartItems)
    },
    async upsertOrder(paymentMethodId, paymentIntentId) {
      const timeResponse = await this.getTime()
      const orderBody = {
        cart_id: this.currentCartItems[0].cart_id,
        delivery_type: this.flow === 'shippable' ? 'shipping' : 'self-service',
        status: this.flow === 'shippable' ? 'pending' : 'delivered',
        payment_intent_id: paymentIntentId,
        payment_method_id: paymentMethodId,
        payment_status: this.delayPayment === true ? 'DELAYED_PENDING' : 'PAID',
        order_time: timeResponse,
        total_cost: Number(this.cartTotalPrice)
      }
      if (this.shippingRate) {
        orderBody.estimated_delivery_days = this.shippingRate.estimated_delivery_days
        orderBody.estimated_delivery_date = this.shippingRate.estimated_delivery_date
        orderBody.estimated_pickup_date = this.shippingRate.estimated_pickup_date
        orderBody.platform = this.shippingRate.platform
        orderBody.service_type = this.shippingRate.service_type
        orderBody.shipping_cost = this.shippingRate.shipping_cost
        orderBody.total_cost += Number(this.shippingRate.shipping_cost)
      }
      const orderData = await this.$store.dispatch('order/upsertOrder', orderBody)
      if (this.delayPayment === false) {
        const invoiceBody = { order_id: orderData.insertId, type: 'stripe_intent', cart_items: this.currentCartItems, paymentMethodId: paymentMethodId, datetime: timeResponse }
        if (this.shippingRate) invoiceBody.shipping_cost = this.shippingRate.shipping_cost
        const invoiceData = await this.$store.dispatch('addInvoice', invoiceBody)
        if (invoiceData) {
          this.updateStock()
          const date = new Date()
          const user = JSON.parse(localStorage.getItem('user'))
          CebelcaService.fiscalizeInvoice({
            email: user.email,
            invoice_id: invoiceData.invoice_id,
            invoice_date: `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`,
            cart_items: this.currentCartItems,
            shipping_cost: (this.shippingRate && this.shippingRate.shipping_cost) ? this.shippingRate.shipping_cost : undefined
          })
        }
      }
    },
    async getTime() {
        return moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    },
    async getPaymentMethod(paymentResponse) {
      const paymentMethod = await this.$store.dispatch('getPaymentMethod', { paymentMethodId: paymentResponse.paymentIntent.payment_method, cartId: this.currentCartItems[0].cart_id})
      return paymentMethod.last4
    }
  },
  props: {
    productDetails: {},
    cartTotalPrice: {
      type: Number,
      default: 0
    },
    cartItems: {
      type: Array
    },
    disablePayment: Boolean,
    disablePaymentCommon: Boolean,
    flow: String,
    shippingRate: Object
  },
  computed: mapState(['order']),
}
</script>

<style lang="scss" scoped>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
  margin-bottom: 10px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  margin-top: -20px;
  max-width: 250px;
  text-align: center;
  vertical-align: top;
}

.info-btn
{
  color: #fff;
  background: var(--primary);
  text-decoration: none !important;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.info-btn:hover{
  background: #0C4F60;
}

// media queries for common device breakpoints 

//Galaxy Fold //
@media only screen and (min-device-width : 270px) and (max-device-width : 280px) {
.about-img2 {
  margin-top: -10px;
  max-width: 200px;
}
}
//
@media only screen and (min-device-width : 281px) and (max-device-width : 320px) {
.about-img2 {
  margin-top: -10px;
  max-width: 200px;
}
}
//iPhone 5 //
@media only screen and (min-device-width : 321px) and (max-device-width : 359px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -15px;
  max-width: 230px;
}
}
//Galaxy S5/S8/Moto S4 //
@media only screen and (min-device-width : 360px) and (max-device-width : 374px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -20px;
  max-width: 250px;
}
}
//iPhone 6/7/8/X/11Pro/12 Mini //
@media only screen and (min-device-width : 375px) and (max-device-width : 389px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -20px;
  max-width: 250px;
}
}
//iPhone 12/12Pro //
@media only screen and (min-device-width : 390px) and (max-device-width : 413px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -23px;
  max-width: 270px;
}
}
//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width : 414px) and (max-device-width : 440px) and (orientation : portrait)  {
.about-img2 {
  margin-top: -25px;
  max-width: 290px;
}
}
</style>
